// Ίδιο query με τα md / lg breakpoints στο tailwind.config.js.
// Desktop = πλάτος >= 1024px ΚΑΙ ποντίκι/trackpad. Όλα τα tablets -> mobile.
export const DESKTOP_QUERY = '(min-width: 1024px) and (hover: hover) and (pointer: fine)';

export const isDesktop = () =>
  typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches;
